import "../header/Header.css";
import { type FC, type ReactNode } from "react";
import React, { useState } from 'react';
import { Box, Typography, MenuItem, Popover, Button } from "@mui/material";
import { useWeb3React } from "@web3-react/core";
import { ContentCopy, LogoutOutlined } from "@mui/icons-material";
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import { useNavigate } from "react-router-dom";
import { useWeb3AuthContext } from "../../contexts/web3Auth";
import { AccountBotton, FormattedAddress, Images, getSearchParams } from "../../utils";
import IconAccountActive from "../../assets/images/icons/active/active-icon-issuer.png";

interface HeaderProps {
    role?: string;
    children?: ReactNode;
}

const Header: FC<HeaderProps> = ({ role, children }) => {

    const navigate = useNavigate();
    const roleParam = getSearchParams("role")!;
    const { active, account, deactivate } = useWeb3React();
    const { logoutWeb3Auth } = useWeb3AuthContext();
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const onCopy = () => {
        setAnchorEl(null);
        if (role === "issuer" || role === "admin" || role === "tokenAction") {
            navigator.clipboard.writeText(account || '');
        } else if (role === "controller") {
            navigator.clipboard.writeText(localStorage.getItem("_address") || '');
        }
    };

    const onDisconnect = () => {
        setAnchorEl(null);
        if (role === "issuer" || role === "admin") {
            disconnectMetamask();
        } else if (role === "controller") {
            logoutWeb3Auth();
        }
    }

    const disconnectMetamask = () => {
        // window.location.reload();
        // window.location.href = process.env.REACT_APP_REDIRECT_URL || '';
        localStorage.setItem("walletConnected", "disconnect");
        deactivate();
        window.location.reload();
        window.location.href = process.env.REACT_APP_REDIRECT_URL || '';
    };

    const configPath = {
        "/issuer/total-supply": "/issuer",
        "/admin/update-holder": "/admin",
        "/admin/change-contract-owner": "/admin",
        // "/issuer/update-holder": "/issuer",
        "/controller/permission": "/",
        "/controller/new-holder/upload-file": "/controller",
        "/controller/update-balance/upload-file": "/controller",
        "/view-data": "/",
        "/status": roleParam === "admin" ? "/admin/change-contract-owner" :
            roleParam === "controller" ? "/controller/update-balance/upload-file" : "/",
    }

    const handleBlack = () => {
        if (window.location.pathname === "/issuer") {
            // disconnectMetamask();
            navigate(`/?tokenAddress=${localStorage.getItem("tokenContractAddress")}`);
        } else if (window.location.pathname === "/admin") {
            // disconnectMetamask();
            navigate(`/?tokenAddress=${localStorage.getItem("tokenContractAddress")}`);
        } else if (window.location.pathname === "/controller") {
            logoutWeb3Auth();
            navigate(`/?tokenAddress=${localStorage.getItem("tokenContractAddress")}`);
        } else if (window.location.pathname === "/") {
            navigate("/tokenAction/manage-contract-address-input");
            localStorage.removeItem("tokenContractAddress");
        } else if (window.location.pathname === "/view-data") {
            navigate(`/?tokenAddress=${localStorage.getItem("tokenContractAddress")}`);
        } else if (window.location.pathname === "/tokenAction/manage-contract-address-input" || window.location.pathname === "/tokenAction/createToken" || window.location.pathname === "/tokenAction/add-exit-token") {
            navigate("/tokenAction");
        }
        else if (window.location.pathname === "/permission") {
            if (roleParam === "nonTokenCreator") {
                navigate("/tokenAction");
            } else if (roleParam === "badAddressManageToken") {
                navigate("/tokenAction/manage-contract-address-input");
            } else if (roleParam === "badAddressAddToken") {

                navigate("/tokenAction/add-exit-token");
            }
            else {
                if (localStorage.getItem("tokenContractAddress")) {
                    navigate(`/tokenAction/manage-contract-address-input?tokenAddress=${localStorage.getItem("tokenContractAddress")}`);
                } else {
                    navigate("/tokenAction/manage-contract-address-input");
                }

            }
        }
        else {
            if (configPath[window.location.pathname as keyof {}]) {
                navigate(configPath[window.location.pathname as keyof {}])
            }
        }
    };

    const open = Boolean(anchorEl);
    const id = open ? 'menu-popover' : undefined;

    return (
        <div
            className={(role !== "issuer" && role !== "admin" && role !== "controller" && role !== "tokenAction") ? "header" : ""}
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
            }}
        >
            {(window.location.pathname !== "/check-balance" &&
                window.location.pathname !== "/controller/permission"
                &&
                window.location.pathname !== "/tokenAction"
            ) &&
                <Button
                    size="small"
                    startIcon={<ArrowBackIosRoundedIcon sx={{ fontSize: 'medium', color: 'var(--black)' }} />}
                    onClick={() => handleBlack()}
                    sx={{
                        margin: "0px 20px",
                        ':hover': {
                            background: 'none'
                        },
                    }}
                >
                    <Typography color={'var(--black)'} fontSize={14} fontWeight={500}>Back</Typography>
                </Button>
            }
            {(active && (role === "issuer" || role === "admin" || role === "tokenAction")) &&
                <Box display={"flex"} justifyContent={"right"} sx={{ m: { xs: "24px 8px", sm: "24px 40px" } }} onClick={(e: any) => handleClick(e)}>
                    <AccountBotton>
                        <Images src={IconAccountActive} alt="done" />
                        <Typography fontWeight={500} fontSize={14} color={'var(--black)'}>{FormattedAddress(account)}</Typography>
                    </AccountBotton>
                </Box>
            }

            {(localStorage.getItem("_address") && role === "controller" && window.location.pathname !== "/controller/permission") &&
                <Box display={"flex"} justifyContent={"right"} sx={{ m: { xs: "24px 8px", sm: "24px 40px" } }} onClick={(e: any) => handleClick(e)}>
                    <AccountBotton>
                        <Images src={IconAccountActive} alt="done" />
                        <Typography fontWeight={500} fontSize={14} color={'var(--black)'}>{FormattedAddress(localStorage.getItem("_address"))}</Typography>
                    </AccountBotton>
                </Box>
            }
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                disableRestoreFocus
                sx={{
                    '& .MuiPopover-paper': {
                        borderRadius: '12px',
                        py: 1
                    }
                }}
            >
                <MenuItem onClick={onCopy}>
                    <ContentCopy className="icon-copy" />
                    <Typography className="copy">
                        Copy address
                    </Typography>
                </MenuItem>
                {
                    (role === "controller" || role === "issuer" || role === "admin") && (
                        <MenuItem onClick={() => onDisconnect()}>
                            <LogoutOutlined className="icon-logout" />
                            <Typography className="logout">
                                Disconnect
                            </Typography>
                        </MenuItem>
                    )
                }
            </Popover>
        </div>
    );
};

export default Header;
